import firebase from "config/firebase";
import { toast } from "react-toastify";
import { fetchDocument } from "./helperAction";

export const fetchStates = () => async (dispatch) => {
  firebase
    .firestore()
    .collection("states")
    .orderBy("name", "asc")
    .onSnapshot((query) => {
      var tempStates = [];
      query.forEach((doc) => {
        tempStates.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: "GET_STATES",
        payload: tempStates,
      });
    });
};
export const fetchSchoolStates = () => async (dispatch) => {
  firebase
    .firestore()
    .collection("school_states")
    .orderBy("name", "asc")
    .onSnapshot((query) => {
      var tempStates = [];
      query.forEach((doc) => {
        tempStates.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: "GET_SCHOOL_STATES",
        payload: tempStates,
      });
    });
};

export const getCollegeCity = (state) => async (dispatch) => {
  firebase
    .firestore()
    .collection("test-colleges-universities")
    .where("state", "==", state)
    .orderBy("city", "asc")
    .onSnapshot((query) => {
      let temp = [];
      query.forEach((doc) => {
        temp.push({
          ...doc.data(),
        });
      });
      dispatch({ type: "GET_CITY_BY_STATE", payload: temp });
    });
};

export const getSchoolCounty = (state) => async (dispatch) => {
  firebase
    .firestore()
    .collection("test_schools")
    .where("state", "==", state)
    .orderBy("county", "asc")
    .onSnapshot((query) => {
      let temp = [];
      query.forEach((doc) => {
        temp.push({
          ...doc.data(),
        });
      });
      dispatch({ type: "GET_COUNTY_BY_STATE", payload: temp });
    });
};

export const newCollegeUniversitiesData =
  (state, college) => async (dispatch) => {
    firebase
      .firestore()
      .collection("test-colleges-universities")
      .where("state", "==", state)
      .where("city", "==", college)
      .onSnapshot((query) => {
        let temp = [];
        query.forEach((doc) => {
          temp.push({
            ...doc.data(),
          });
        });
        dispatch({ type: "NEW_COLLEGE_UNIVERSITIES", payload: temp });
      });
  };

export const createComplaint = (obj, onSuccess) => {
  return async (dispatch) => {
    dispatch({
      type: "GENERATE_COMPLAINT",
    });
    firebase
      .firestore()
      .collection("complaints")
      .add(obj)
      .then(async (res) => {
        const newDocId = res.id;
        const notificationData = {
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          type: "athlete-issue",
          notifyID: newDocId,
          status: false,
        };
        await firebase
          .firestore()
          .collection("admin_notifiaction")
          .add(notificationData);
        dispatch({
          type: "GENERATE_COMPLAINT_END",
        });
        toast.success("Issue Submitted Successfully");
        onSuccess();
      })
      .catch((err) => {
        dispatch({
          type: "GENERATE_COMPLAINT_END",
        });
        toast.warning(err.message);
      });
  };
};

export const updateComplaint = (data, id, onSuccess) => async (dispatch) => {
  try {
    await firebase
      .firestore()
      .collection("complaints")
      .doc(id)
      .update(data)
      .then((res) => {
        onSuccess();
        toast.success("Issue updated successfully");
      });
  } catch (error) {
    console.error(error);
  }
};

export const getIssues = (id, lastDocument, onSuccess = () => {}) => {
  return async (dispatch) => {
    try {
      let query = firebase
        .firestore()
        .collection("complaints")
        .where("issue_by", "==", id)
        .orderBy("created_at", "desc");
      if (lastDocument) {
        query = query.startAfter(lastDocument);
      }
      const unsubscribe = query.limit(5).onSnapshot(
        (snapshot) => {
          let temp_data = [];
          snapshot.forEach((doc) => {
            temp_data.push({
              id: doc.id,
              ...doc.data(),
            });
          });

          dispatch({
            type: lastDocument
              ? "GET_ATHLETE_ISSUES_MORE"
              : "GET_ATHLETE_ISSUES",
            payload: {
              data: temp_data,
              lastDocument: snapshot.docs[temp_data.length - 1] || null,
              hasMoreDocument: temp_data.length >= 5,
            },
          });

          onSuccess(temp_data);
          unsubscribe();
        },
        (error) => {
          console.error("Error fetching issues:", error);
          onSuccess([]);
        }
      );
    } catch (error) {
      console.error("Error in getIssues:", error);
    }
  };
};

export const deleteIssue = (id, onSuccess) => {
  return async (dispatch) => {
    try {
      const currentUser = firebase.auth().currentUser;
      if (!currentUser) throw new Error("Not authenticated");
      
      const docRef = firebase.firestore().collection("complaints").doc(id);
      const docSnap = await docRef.get();
      
      if (docSnap.exists && docSnap.data().issue_by === currentUser.uid) {
        await docRef.delete();
        toast.success("Issue deleted successfully");
        if (onSuccess) onSuccess();
      } else {
        toast.error("Unauthorized to delete this issue.");
      }
    } catch (error) {
      console.error("Error deleting issue:", error);
      toast.error("Failed to delete issue. Please try again.");
    }
  };
};

export const addInstantChatEmailInUser =
  (id, email, onComplete = () => {}) =>
  async (dispatch) => {
    await firebase
      .firestore()
      .collection("users")
      .doc(id)
      .update({
        a4bEmail: email,
      })
      .then(() => {
        toast.success("Email successfully added to user");
        onComplete();
      })
      .catch((error) => {
        toast.success(error);
      });
  };

export const getAthleteDataById = (id, onSuccess = () => {}) => {
  return async (dispatch) => {
    try {
      const querySnapshot = await firebase
        .firestore()
        .collection("users")
        .where("athleteID", "==", id)
        .get();

      const userData = [];
      querySnapshot.forEach((doc) => {
        userData.push({ id: doc.id, ...doc.data() });
      });

      dispatch({ type: "ATHLETE_DATA_RECEIVED", payload: userData[0] });
      onSuccess(userData[0]);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
};

export const fetchAthleteSchool = ({ city, state, schoolName }) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        const queryOptions = [
          { method: "where", args: ["county", "==", city] },
          { method: "where", args: ["state", "==", state] },
          { method: "where", args: ["instituteName", "==", schoolName] },
        ];
        const response = await fetchDocument({
          collectionName: "users",
          queryOptions,
        });

        dispatch({
          type: "FETCH_ATHLETE_SCHOOL_SUCCESS",
          payload: response,
        });
        resolve(response);
      } catch (error) {
        toast.error(error.message || "Unable to fetch athlete school");
        reject(error);
      }
    });
  };
};
